import Box from "@mui/material/Box"
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Login from "./Components/Login"
import Registro from "./Components/Registro"
import { auth } from "./Firebase"
import { loginToken } from "./Redux/token"
import { actualizarAccountid, leerUsuarioActivo } from "./Redux/usuarios"
import TokenContext from "./context/TokenContext"
import { themeSettings } from "./theme"

import Inicio from "./Components/Inicio"
import ProtectedRoute from "./Components/ProtectedRoute"
import { AuthContextProvider } from "./context/AuthContext"
import Asignaciones from "./Components/Asignaciones"
import DesempenioAutoEvaluacion from "./Components/DesempenioAutoEvaluacion"
import EncuestaDocente from "./Components/EncuestaDocente"
import EvaluacionFeedback from "./Components/EvaluacionFeedback"
import Evaluaciones from "./Components/Evaluaciones"
import GHResponde from "./Components/GHResponde"
import Legajo from "./Components/Legajo"
import Novedades from "./Components/Novedades"
import NovedadesLiquidacion from "./Components/NovedadesLiquidacion"
import PGD from "./Components/PGD"
import UniversidadInterna from "./Components/UniversidadInterna"
import Vacaciones from "./Components/Vacaciones"
import { AnimatePresence, motion } from "framer-motion";
import Licencias from './Components/Licencias';
import Solicitudes from './Components/Solicitudes';
import AceptacionAsignacion from './Components/AceptacionAsignacion';
import AceptacionAsignacionActividades from './Components/AceptacionAsignacionActividades';
import AccesoDenegado from './Components/AccesoDenegado';

import SubperiodoVacacional from "./Components/SubperiodoVacacional"

import Desempeno from "./Components/Desempeno"
import GDResponde from "./Components/GDResponde"
import AreaAcademica from "./Components/AreaAcademica"
import InformacionEventos from "./Components/InformacionEventos"
import AreaPrincipal from "./Components/AreaPrincipal"
import OtraInformacion from "./Components/OtraInformacion"
import Formacion from "./Components/Formacion"
import ComitesJurados from "./Components/ComitesJurados"
import ReunionesCientificas from "./Components/ReunionesCientificas"
import DocenciaUniversitaria from "./Components/DocenciaUniversitaria"
import GestionAcademica from "./Components/GestionAcademica"
import Investigacion from "./Components/Investigacion"
import LoginDocente from "./Components/LoginDocente"
import UniversidadInternaCodocente from "./Components/UniversidadInternaCodocente"
import Organigrama from "./Components/Organigrama"
import LoginAdmin from "./Components/LoginAdmin"
import SessionManager from "./Components/SessionManager"



function App() {
  const [llamadaToken, setLLamadaToken] = React.useState(false)
  const [expiracionTkn, setExpiracionTkn] = React.useState(null)
  const [refreshTkn, setRefreshTkn] = React.useState(null)
  const refreshtokenSelector = useSelector((store) => store.token.refreshToken)
  const dispatch = useDispatch()
  const [mode, setMode] = React.useState("dark")
  const theme = React.useMemo(() => createTheme(themeSettings(mode)), [mode])

  const [tkn, setTkn] = React.useState("")
  const tokenSelector = useSelector((store) => store.token.token)

  const [loggedUser, setLoggedUser] = React.useState(false)

  const obtenerToken = () => {
    dispatch(loginToken())
  }

  React.useEffect(() => {
    const refreshInterval = setInterval(() => {
      dispatch(loginToken())
    }, 1800000) // Llamada cada 30 minutos

    return () => clearInterval(refreshInterval)
  }, [])

  React.useEffect(() => {
    if (Object.keys(tokenSelector).length !== 0) {
      setTkn(tokenSelector.token)
      const expiration = tokenSelector.expiracion
      localStorage.setItem("token", JSON.stringify({ token: tokenSelector.token, expiracion: expiration }))
    }
  }, [tokenSelector])

  React.useEffect(() => {
    const fetchUser = () => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          // if (localStorage.getItem('empleado') && localStorage.getItem('token')) {
          //   const storedToken = JSON.parse(localStorage.getItem('token'));
          //   dispatch(leerUsuarioActivo());
          //   setTkn(storedToken.token);
          // }
          if (localStorage.getItem("empleado")) {
            obtenerToken()
            dispatch(leerUsuarioActivo())
          } else {
            obtenerToken()
            dispatch(actualizarAccountid(user.uid))
          }
          setTimeout(() => {
            setLoggedUser(true)
          }, 2000)
        } else {
          clearCacheData()
          setLoggedUser(false)
        }
      })
    }

    fetchUser()
  }, [])

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name)
      })
    })
  }

  const cambiarColor = () => {
    setMode((prevMode) => {
      return prevMode === "dark" ? "light" : "dark"
    })
  }


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
        <TokenContext.Provider value={tkn}>
          <BrowserRouter basename="">
            <AuthContextProvider>
              <SessionManager stateLoggin={loggedUser} />
              <AnimatePresence mode='wait'>
                <Routes>
                  <Route
                    path="/inicio"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Inicio />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/legajo"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Legajo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/area-academica"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <AreaAcademica />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/formacion"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Formacion />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/area-principal"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <AreaPrincipal />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/docencia-universitaria"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <DocenciaUniversitaria />
                      </ProtectedRoute>
                    }
                  />
                  {/* <Route
                    path="/gestion-academica"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <GestionAcademica />
                      </ProtectedRoute>
                    }
                  /> */}
                  <Route
                    path="/investigacion"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Investigacion />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reuniones-cientificas"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <ReunionesCientificas />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/comites-jurados"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <ComitesJurados />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/otra-informacion"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <OtraInformacion />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/licencias"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Licencias />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/solicitudes"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Solicitudes />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pgd"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <PGD />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/evaluacion-feedback/:id"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <EvaluacionFeedback />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/programa-gestion-de-desempeno-autoevaluacion/:id"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <DesempenioAutoEvaluacion />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/desempeno"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Desempeno />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vacaciones"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Vacaciones />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/subperiodo"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <SubperiodoVacacional />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/gh-responde"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <GHResponde />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/gd-responde"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <GDResponde />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/universidad-interna-docente"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <UniversidadInterna />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/universidad-interna"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <UniversidadInternaCodocente />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/informacion-eventos/:id"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <InformacionEventos />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/evaluaciones"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Evaluaciones />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/encuestas-docente"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <EncuestaDocente />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/novedades"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Novedades />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/novedades-liquidacion"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <NovedadesLiquidacion />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/asignaciones"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Asignaciones />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/aceptacion-asignacion/:id"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <AceptacionAsignacion />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/aceptacion-asignacion-actividades/:id"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <AceptacionAsignacionActividades />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/organigrama"
                    element={
                      <ProtectedRoute cambiarColor={cambiarColor}>
                        <Organigrama />
                      </ProtectedRoute>
                    }
                  />
                  <Route path='/'>
                    <Route index element={<Login />} />
                  </Route>
                  <Route path='/login-portal'>
                    <Route index element={<LoginDocente />} />
                  </Route>
                  <Route path='/login-admin'>
                    <Route index element={<LoginAdmin />} />
                  </Route>
                  <Route path="/registro">
                    <Route index element={<Registro />} />
                  </Route>
                  <Route path='/acceso-denegado'>
                    <Route index element={<AccesoDenegado />} />
                  </Route>
                </Routes>
              </AnimatePresence>
            </AuthContextProvider>
          </BrowserRouter>
        </TokenContext.Provider>
      </Box>
    </ThemeProvider>
  )
}

export default App
